import KelloggsVsCompetitorPromotionFrequencyChart from "./KelloggsVsCompetitorPromotionFrequencyChart";
export default KelloggsVsCompetitorPromotionFrequencyChart;
